<template>
  <div class="container">
    <!--b-field label="Oberflächenveredelung" class="px-3 py-2 has-background-light">
      <b-select expanded placeholder="Unbehandelt" v-model="selectedFinishId" @change="invalidatePricing()">
        <option v-for="surfaceFinish in availableSurfaceFinishes" :value="surfaceFinish._id">{{surfaceFinish.name}}</option>
        <option :value="null">Unbehandelt</option>
      </b-select>
    </b-field-->
    <div class="materials__select">
      <div
        class="select__material-option"
        v-for="printMode in printModes"
        :key="`print-mode-option_${printMode.id}`"
        @click="selectPrintMode(printMode.id)"
        :class="selectedClass(printMode)"
      >
        <PrintModeOption
          :is-selected="selectedPrintModeId === printMode.id"
          :is-loading="isLoading"
          :print-mode="printMode"
        ></PrintModeOption>
      </div>
      <div class="has-text-grey px-3 py-2">
        * <span>{{ $t("checkout.cart.isPiecePrice") }}, </span
        ><span v-if="!isBusinessCustomer">{{
          $t("checkout.cart.includingXPercentTaxes", { taxRate })
        }}</span>
        <span v-else>{{
          $t("checkout.cart.plusXPercentTaxes", { taxRate })
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PrintModeOption from "./PrintModeOption";
import axios from "axios";
import { eventBus } from "../../../events/event-bus";

export default {
  name: "PrintModeSelect",
  components: { PrintModeOption },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters([
      "printModes",
      "current3DFile",
      "currentCartItem",
      "printModeById",
      "taxRate",
      "isBusinessCustomer",
      "availableSurfaceFinishes",
    ]),
    selectedPrintModeId: {
      get() {
        return this.currentCartItem.printModeId;
      },
      set(value) {
        let printMode = this.printModeById(value);
        this.$store.dispatch("updateCurrentCartItem", {
          printModeId: value,
          surfaceFinishId: printMode.surfaceFinishes[0].id,
          selectedColorId: printMode.surfaceFinishes[0].id,
        });
      },
    },
    selectedFinishId: {
      get() {
        return this.currentCartItem.surfaceFinishId;
      },
      set(value) {
        this.$store.dispatch("updateCurrentCartItem", {
          surfaceFinishId: value,
        });
      },
    },
    selectedColorId: {
      get() {
        return this.currentCartItem.colorId;
      },
      set(value) {
        this.$store.dispatch("updateCurrentCartItem", {
          colorId: value,
        });
      },
    },
  },
  methods: {
    selectedClass(printMode) {
      return {
        "is-selected": printMode.id === this.selectedPrintModeId,
        "is-paddingless": !printMode,
      };
    },
    selectPrintMode(id) {
      this.selectedPrintModeId = id;
      this.selectedFinishId = this.printModeById(id).surfaceFinishes[0].id;
      this.selectedColorId = this.printModeById(
        id
      ).surfaceFinishes[0].colors[0].id;
    },
  },
  created() {
    let defaultPrintMode = Object.values(this.printModes)[0];
    let defaultSurfaceFinish = defaultPrintMode.surfaceFinishes[0];
    let defaultColor = defaultSurfaceFinish.colors[0];

    if (this.currentCartItem.printModeId) {
      this.isLoading = false;
      return;
    }

    if (defaultPrintMode) {
      this.selectedPrintModeId = defaultPrintMode.id;
    }

    this.$store.dispatch("updateCurrentCartItem", {
      printModeId: defaultPrintMode.id,
      color: defaultColor,
      surfaceFinishId: defaultSurfaceFinish.id,
    });
    eventBus.cartItemPricingInvalid();
    this.isLoading = false;
  },
};
</script>
